import { type Certifications } from '@tmdb-graphql-api/schema/types';
import { type CertificationCountry, type Config } from '#types.ts';
import { type Mark } from '../../../Form/RangeSlider/types.ts';

const isCertificationCountry = (
  certifications: Certifications,
  country: Config['country'],
): country is CertificationCountry => country in certifications;

export const formatCertifications = (certifications: Certifications = {}, { country }: Config) => {
  const countryCertifications = isCertificationCountry(certifications, country) ? certifications[country] : undefined;

  if (!countryCertifications) {
    return;
  }

  const formattedCertifications = countryCertifications.reduce((acc: Mark[], entry) => {
    if (!entry) {
      return acc;
    }

    const { certification, order } = entry;
    acc.push({ label: certification, value: order });
    return acc;
  }, []);

  if (formattedCertifications.some(({ value }) => value !== 0)) {
    return formattedCertifications;
  }

  return formattedCertifications.map(({ label, value }) => ({ label, value: value + 1 }));
};
